import { apiGet, apiPost } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const skillBadgeApi = {
  /**
   * Fetches the skill badges for a user with the given auxo_user_id.
   * @apiRoute GET '/skill-badges/user/<auxo_user_id>'
   */
  async getUserSkillBadges(auxo_user_id) {
    try {
      const response = await apiGet(
        getPath(`skill-badges/user/${auxo_user_id}`)
      );
      return response.data;
    } catch (err) {
      await handleApiError(err, 'getUserSkillBadges');
    }
  },

  /**
   * Marks a skill badge notification as seen for a user.
   * @apiRoute POST '/skill-badges/user/<auxo_user_id>/seen/<badge_id>/<tier_number>'
   */
  async setNotificationsToSeen(auxo_user_id, badge_id, tier_number) {
    try {
      const response = await apiPost(
        getPath(
          `skill-badges/user/${auxo_user_id}/seen/${badge_id}/${tier_number}`
        )
      );
      return response.data;
    } catch (err) {
      await handleApiError(err, 'setNotificationsToSeen');
    }
  },

  /**
   * Fetches unseen skill badge notifications for a user.
   * @apiRoute GET '/skill-badges/user/<auxo_user_id>/notifications'
   */
  async getUnseenNotifications(auxo_user_id) {
    try {
      const response = await apiGet(
        getPath(`skill-badges/user/${auxo_user_id}/notifications`)
      );
      return response.data;
    } catch (err) {
      await handleApiError(err, 'getUnseenNotifications');
    }
  },
};
